/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponsePaging } from './ListOperations200ResponsePaging';
import {
    ListOperations200ResponsePagingFromJSON,
    ListOperations200ResponsePagingFromJSONTyped,
    ListOperations200ResponsePagingToJSON,
    ListOperations200ResponsePagingToJSONTyped,
} from './ListOperations200ResponsePaging';
import type { ListStatements200ResponseItemsInner } from './ListStatements200ResponseItemsInner';
import {
    ListStatements200ResponseItemsInnerFromJSON,
    ListStatements200ResponseItemsInnerFromJSONTyped,
    ListStatements200ResponseItemsInnerToJSON,
    ListStatements200ResponseItemsInnerToJSONTyped,
} from './ListStatements200ResponseItemsInner';

/**
 * 
 * @export
 * @interface ListStatements200Response
 */
export interface ListStatements200Response {
    /**
     * 
     * @type {Array<ListStatements200ResponseItemsInner>}
     * @memberof ListStatements200Response
     */
    items?: Array<ListStatements200ResponseItemsInner>;
    /**
     * 
     * @type {ListOperations200ResponsePaging}
     * @memberof ListStatements200Response
     */
    paging?: ListOperations200ResponsePaging;
}

/**
 * Check if a given object implements the ListStatements200Response interface.
 */
export function instanceOfListStatements200Response(value: object): value is ListStatements200Response {
    return true;
}

export function ListStatements200ResponseFromJSON(json: any): ListStatements200Response {
    return ListStatements200ResponseFromJSONTyped(json, false);
}

export function ListStatements200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListStatements200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(ListStatements200ResponseItemsInnerFromJSON)),
        'paging': json['paging'] == null ? undefined : ListOperations200ResponsePagingFromJSON(json['paging']),
    };
}

export function ListStatements200ResponseToJSON(json: any): ListStatements200Response {
    return ListStatements200ResponseToJSONTyped(json, false);
}

export function ListStatements200ResponseToJSONTyped(value?: ListStatements200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(ListStatements200ResponseItemsInnerToJSON)),
        'paging': ListOperations200ResponsePagingToJSON(value['paging']),
    };
}

